import { PublicKey } from "@solana/web3.js";
import { ENV_NAME, RPC_WRITE_ENDPOINTS } from "../../utils/env/env";

export const IS_MAINNET: boolean = ENV_NAME == 'MAINNET'

// RPC ENDPOINTS
export const RPC_WRITE_ENPOINTS = RPC_WRITE_ENDPOINTS?.split(',')

export const NFT_CRANKER = IS_MAINNET ? new PublicKey('8hfyiv9XuheUZSLPb3o3UoxvR3DQGsoB4QMk9uNjLvPz'): new PublicKey('7DcLHYEtsTvqzhvSuNXCQAmaJH58KoQiqdo5ps5QuqvY')
